import React from 'react';

const ErrorPage = (props) => {
    document.title = props.title;

    return (
        <section className="pnc-contact-us">
            <div className="container">
                <div className="row">
                    <div className="offset-md-1 col-md-11">
                        <div className="contact_us">

                            <div className="alert alert-danger" role="alert">
                                 User not found
                            </div>

                            <h3 aria-level="1">THANK YOU FOR VISITING PNC Yorktown</h3>

                            <h5>An error occurred when you requested this page.</h5>

                            <p>We apologize for the inconvenience this may have caused you.</p>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ErrorPage;